<template>
  <MessageBoxBase
    class="com_message-box--info"
  >
    <slot />
  </MessageBoxBase>
</template>

<script>
import MessageBoxBase from '@/components/MessageBoxBase.vue'

export default {
  name: 'MessageBoxInfo',

  components: {
    MessageBoxBase,
  },
}
</script>
